<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

(function() {
  function addTargetBlank() {
    document.querySelectorAll('.list-social__link[href]').forEach(function(link) {
      if (link.getAttribute('target') !== '_blank') {
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener noreferrer');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addTargetBlank);
  } else {
    addTargetBlank();
  }

  setTimeout(addTargetBlank, 1000);
  
  var observer = new MutationObserver(addTargetBlank);
  observer.observe(document.body, { childList: true, subtree: true });
})();

